import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getContactList } from '../../../store/groups/actions';
import { formatBrowserTimeZone, customBrowserFormat } from '../../../components/common/DateTimeFormatter';
import { GetAllLocation } from '../../../api/groupsapi';
import { formatPhoneNumberAsYouType } from "../../../helpers/formatterHelper";
import { useNavigate } from 'react-router-dom';

function Contacts() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [filter, setFilter] = useState({ sort: 0, searchby: '', locationId: 0, start: 0, length: 100, phoneNumberStatus: 0 });
    const { contactList } = useSelector(state => state.grouplists);
    const [locations, setLocations] = useState([]);
    const totalCountContact = contactList[0]?.totalCount;
    const [selectedStatus, setSelectedStatus] = useState(0);
    useEffect(() => {
        const updatedFilter = { ...filter };
        dispatch(getContactList(updatedFilter));
    }, [dispatch, filter]);

    useEffect(() => {
        GetAllLocation().then((response) => {
            if (response?.data?.success) setLocations(response.data.data);
        });
    }, []);

    const getMaxAppointmentDate = (appointments) => {
        if (!appointments || appointments.length === 0) {
            return null;
        }
        const appointmentDates = appointments.map((appointment) =>
            new Date(appointment.appointmentDateTime)
        );
        const maxDate = new Date(Math.max.apply(null, appointmentDates));
        return maxDate;
    };
    const handleStatusButtonClick = (status) => {
        // Set the selected status
        setSelectedStatus(status);
        setFilter({ ...filter, phoneNumberStatus: status });
    };

    const handleSelectChange = (e) => {
        const selectedLocationId = parseInt(e.target.value);
        setFilter({ ...filter, locationId: selectedLocationId, start: 0 });
    }; 
    const generatePageNumbers = () => {
        const totalPages = Math.ceil(totalCountContact / filter.length);
        const currentPage = Math.floor(filter.start / filter.length) + 1;
        const maxMiddlePages = 5; 

        const firstPages = Array.from({ length: Math.min(3, totalPages) }, (_, i) => i + 1);
        const lastPages = Array.from({ length: Math.min(3, totalPages - firstPages.length) }, (_, i) => totalPages - i);

        let middlePages = [];
        if (totalPages > firstPages.length + lastPages.length) {
            const startMiddle = Math.max(firstPages.length + 1, currentPage - Math.floor(maxMiddlePages / 2));
            const endMiddle = Math.min(startMiddle + maxMiddlePages - 1, totalPages - lastPages.length);

            middlePages = Array.from({ length: endMiddle - startMiddle + 1 }, (_, i) => startMiddle + i);
        }

        const allPages = [...firstPages, ...middlePages, ...lastPages].sort((a, b) => a - b); // Sort the pages

        const pageNumbers = allPages.map((pageNumber, index) => {
            const newStart = (pageNumber - 1) * filter.length;
            return (
                <React.Fragment key={pageNumber}>
                    {index > 0 && pageNumber !== allPages[index - 1] + 1 && index < allPages.length - 1 && <span>...</span>}
                    <button
                        onClick={() => setFilter({ ...filter, start: newStart })}
                        className={filter.start === newStart ? 'active' : ''}
                    >
                        {pageNumber}
                    </button>
                </React.Fragment>
            );
        });

        return pageNumbers;
    };
    return (
        <>
            <div className="admin-page-wrap contacts-page-wrapper">
                <div className="pageContainer page-container-scroll">
                    <div className="admin-page-content w-100">
                        <div className="admin-page-title-wrap">
                            <h1 className="admin-page-heading">Contacts</h1>
                        </div>
                        <div className="admin-container">
                            <div className="admin-bottom-bar filter-bar justify-content-between flex-wrap">
                                <div className="admin-bottom-bar-left">
                                    <input className="admin-default-search quoteradius"
                                                    type="text"
                                                    placeholder="Search by Name or Phone Number"                                    
                                                    value={filter.searchby}
                                                    onChange={(e) => setFilter({ ...filter, searchby: e.target.value, start: 0 })}
                                    />
                                </div>
                                <div className="admin-bottom-bar-right quoteradius quoteradius-btn-wrapper">
                                    <button
                                        className={`admin-button ${selectedStatus === 0 ? 'admin-activetab-btn' : 'admin-tab-btn'}`}
                                        onClick={() => handleStatusButtonClick(0)}
                                    >
                                        <span>Active</span>
                                    </button>
                                    <button
                                        className={`admin-button ${selectedStatus !==0 ? 'admin-activetab-btn' : 'admin-tab-btn'}`}
                                        onClick={() => handleStatusButtonClick(3)}
                                    >
                                        <span>Inactive</span>
                                    </button>
                                </div>
                            </div>

                        {/*<div className="admin-bottom-bar filter-bar">*/}
                        {/*    <div className="admin-bottom-bar-left search-box-wrapper position-relative w-100">*/}
                        {/*        <input className="admin-default-search quoteradius w-100"*/}
                        {/*            type="text"*/}
                        {/*            placeholder="Search by Name or Phone Number"                                    */}
                        {/*            value={filter.searchby}*/}
                        {/*            onChange={(e) => setFilter({ ...filter, searchby: e.target.value, start: 0 })}*/}
                        {/*        />*/}
                        {/*    </div>*/}

                        {/*    <div className="admin-bottom-bar-right quoteradius quoteradius-btn-wrapper">*/}
                        {/*        <button>*/}
                        {/*            <span>Open</span>*/}
                        {/*        </button>*/}
                        {/*        <button>*/}
                        {/*            <span>No Response</span>*/}
                        {/*        </button>*/}
                                

                        {/*    </div>*/}


                        {/*</div>*/}
                        <div className="pt">
                            <table className="admin-table w-100">
                                <thead>
                                    <tr>                                     
                                        <th onClick={() => setFilter({ ...filter, sort: filter.sort == 0 ? 1 : 0 })} className={filter.sort == 0 ? 'admin-table-name-cell sortable sorted-dn' : (filter.sort == 1 ? 'admin-table-name-cell sortable sorted-up' : 'admin-table-name-cell sortable')}>Last Name</th>
                                        <th onClick={() => setFilter({ ...filter, sort: filter.sort == 2 ? 3 : 2 })} className={filter.sort == 2 ? 'admin-table-name-cell sortable sorted-dn' : (filter.sort == 3 ? 'admin-table-name-cell sortable sorted-up' : 'admin-table-name-cell sortable')}>First Name</th>
                                        <th onClick={() => setFilter({ ...filter, sort: filter.sort == 4 ? 5 : 4 })} className={filter.sort == 4 ? 'admin-table-name-cell sortable sorted-dn' : (filter.sort == 5 ? 'admin-table-name-cell sortable sorted-up' : 'admin-table-name-cell sortable')}>Phone Number</th>
                                        <th className="admin-table-name-cell">

                                            <select className="admin-default-select" onChange={handleSelectChange} value={filter.locationId} >
                                                <option value="0">All</option>
                                                {locations.map((option, index) => (
                                                    <option key={index} value={option.id}>
                                                        {option.name}
                                                    </option>
                                                ))}
                                            </select>

                                        </th>
                                        <th className="admin-table-name-cell space-nowrap">Last Appointment</th>
                                    </tr>
                                </thead>
                                <tbody>

                                    {contactList && contactList.map((item, index) => {
                                        const maxAppointmentDate = getMaxAppointmentDate(item.appointments);
                                        const locationNames = item.appointments?.map(appointment => appointment?.location?.name);
                                        return (
                                            <tr key={index} onClick={() => navigate('/history/' + item?.phoneNumberId)} className="cursor-pointer" >
                                                <td className="admin-table-name-cell">
                                                    <span className="bold space-nowrap">{item?.lastName}</span><br />
                                                </td>
                                                <td className="admin-table-name-cell">
                                                    <span className="bold space-nowrap">{item?.firstName}</span>
                                                </td>
                                                <td className="admin-table-name-cell">
                                                    <span className="bold space-nowrap">
                                                        {formatPhoneNumberAsYouType(item?.phoneNumber?.number)}
                                                    </span>
                                                </td>
                                                <td className="admin-table-name-cell">
                                                    <span>
                                                        {Array.from(new Set(locationNames)).length > 0
                                                            ? Array.from(new Set(locationNames)).join(', ') : ''}
                                                    </span>
                                                </td>
                                                <td className="admin-table-name-cell">
                                                    <span className="admin-round-swatch-container">
                                                        {maxAppointmentDate ? <div>
                                                            <div>{customBrowserFormat(maxAppointmentDate)}</div>
                                                            <div>@ {formatBrowserTimeZone(maxAppointmentDate)}</div>
                                                        </div> : 'No appointments'}
                                                    </span>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>                    
                        </div>
                        {totalCountContact > filter.length && (
                            <div className="flex-center pagination-wrapper">
                                <button
                                    className="pagination-prev-btn"
                                    onClick={() => setFilter({ ...filter, start: Math.max(0, filter.start - filter.length) })}
                                    disabled={filter.start <= 0}
                                >
                                    <span className="material-symbols-rounded">arrow_back_ios</span>
                                </button>
                                {generatePageNumbers()}
                                <button
                                    className="pagination-forword-btn"
                                    onClick={() => {
                                        const activePage = Math.floor((filter.start + filter.length) / filter.length);
                                        const nextPageStart = activePage * filter.length;
                                        setFilter({ ...filter, start: nextPageStart });
                                    }}
                                    disabled={filter.start + filter.length >= totalCountContact}
                                >
                                    <span className="material-symbols-rounded">arrow_forward_ios</span>
                                </button>
                            </div>
                        )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Contacts;